import CompanyFileds from './company'
import PatientFileds from './patient'
import ProfessionalFileds from './professional'
import Dweller from './dweller'

export default (Vue) => {
  CompanyFileds(Vue)
  PatientFileds(Vue)
  ProfessionalFileds(Vue)
  Dweller(Vue)

  Vue.component('f-text', () => import('./text'))
  Vue.component('f-checkbox', () => import('./checkbox'))
  Vue.component('f-email', () => import('./email'))
  Vue.component('f-number', () => import('./number'))
  Vue.component('f-password', () => import('./password'))
  Vue.component('f-select', () => import('./select'))
  Vue.component('f-select-status', () => import('./select-status'))
  Vue.component('f-select-custom', () => import('./select-custom'))
  // Vue.component('f-select2', () => import('./select2'))
  Vue.component('f-select-yes-no', () => import('./select-yes-no'))
  Vue.component('f-select-state', () => import('./select-state'))
  Vue.component('f-select-net-treatment', () => import('./select-net-treatment'))
  Vue.component('f-select-ajax', () => import('./select-ajax'))
  Vue.component('f-select-city', () => import('./select-city'))
  Vue.component('f-select-company-speciality', () => import('./select-company-speciality'))
  Vue.component('f-select-company-covenant', () => import('./select-company-covenant'))
  Vue.component('f-select-specialization', () => import('./select-specialization'))
  Vue.component('f-select-type-specialization', () => import('./select-type-specialization'))
  Vue.component('f-select-user-location', () => import('./select-user-location'))
  Vue.component('f-select-covenant', () => import('./select-covenant'))
  Vue.component('f-currency', () => import('./masked/currency'))
  Vue.component('f-percent', () => import('./masked/percent'))
  Vue.component('f-date', () => import('./date/date'))
  Vue.component('f-file', () => import('./file'))
  Vue.component('f-file-avatar', () => import('./file-avatar'))

  Vue.component('f-file-content', () => import('./file-content'))
  Vue.component('f-file-text', () => import('./file-text'))

  Vue.component('f-avatar', () => import('./avatar/avatar'))
  Vue.component('f-dweller-image-book', () => import('./avatar/dweller-image-book'))

  Vue.component('f-file-document-cart', () => import('./file-document-cart'))
  Vue.component('f-file-document-cpf', () => import('./file-document-cpf'))
  Vue.component('f-file-document-dipl', () => import('./file-document-dipl'))
  Vue.component('f-file-document-cert', () => import('./file-document-cert'))
  Vue.component('f-file-document-cend', () => import('./file-document-cend'))
  Vue.component('f-file-document-cnpj', () => import('./file-document-cnpj'))
  Vue.component('f-file-document-outr', () => import('./file-document-outr'))

  Vue.component('zip-code', () => import('./zip-code'))
  Vue.component('f-select-professional-speciality', () => import('./select-professional-speciality'))
  Vue.component('f-select-genre', () => import('./select-genre'))
  Vue.component('f-select-entities-register', () => import('./select-entity-register'))
  Vue.component('v-text', () => import('./validate/v-text'))
  Vue.component('v-phone', () => import('./validate/v-phone'))
  Vue.component('v-date', () => import('./validate/v-date'))
  Vue.component('v-datepicker', () => import('./datepicker/date-picker'))
  Vue.component('v-picker-months', () => import('./datepicker/date-picker-months'))
  // Vue.component('v-select', () => import('./bootstrap-select/bootstrap-select'))
  Vue.component('v-mult-select', () => import('./bootstrap-select/components/Select'))
  Vue.component('select-picker', () => import('./select-picker/select-picker'))
  Vue.component('f-numeric', () => import('./numeric'))
  Vue.component('f-select-all-speciality', () => import('./select-all-speciality'))
  Vue.component('f-select-company-staff-professional', () => import('./company/select-company-staff-professional'))

  Vue.component('f-editor', () => import('./editor'))
  Vue.component('f-select-type-speciality-group', () => import('./select-professional-speciality-group'))
  Vue.component('company_information', () => import('./company_information'))
  Vue.component('personal-information', () => import('./personal_information'))
  Vue.component('type-clinic', () => import('./typeClinic'))
}



// WEBPACK FOOTER //
// ./src/components/form/fields/index.js